export function buildPromotionCreateUrl(productId?: string | null) {
  const params = new URLSearchParams()

  if (productId?.trim()) {
    params.set('productId', productId.trim())
  }

  params.set('create', 'true')
  return `/app/promotions?${params.toString()}`
}
